<keywords-help-modal
  *ngIf="showHelpModal"
  (onClose)="showHelpModal=false"
></keywords-help-modal>

<keywords-layout [isVideoSubscription]="isVideoSubscription">
  <div *ngIf="isCustomerCurrent">
    <div class="d-flex flex-row justify-content-between align-items-end">
      <div *ngIf="filters.search">
        <h3>Searching "{{filters.search}}"</h3>
      </div>
    </div>

    <div
      *ngIf="customerId === customer?.id && !isVideoSubscription"
      class="mt-2 d-flex flex-row align-items-center"
    >
      <div
        *ngIf="contentTypesEnabled"
        class="btn-group"
        dropdown
        placement="bottom left"
      >
        <button dropdownToggle class="btn btn-sm btn-primary">
          <i class="mr-1 fas fa-plus"></i>
          New Request
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-left">
          <li *ngFor="let contentType of filterTypes(contentTypes)"><a class="dropdown-item" [routerLink]="['new', contentType.id]">{{contentType.name}}</a></li>
          <li><a class="dropdown-item" href="https://help.verblio.com/quick-guide-to-verblio/how-to-specify-content-types" target="_blank">Looking for another type? <i class="ml-1 fas fa-question-circle text-primary"></i></a></li>
        </ul>
      </div>
      <div *ngIf="!contentTypesEnabled">
        <a class="btn btn-sm btn-primary" [routerLink]="['new', blogContentTypeId]">
          <i class="mr-1 fas fa-plus"></i>
          New Request
        </a>
      </div>
      <a
        *ngIf="adminImpersonating"
        class="btn btn-default btn-sm ml-2"
        [routerLink]="['admin_upload']"
      >Admin Upload</a>
      <persistent-dropdown *ngIf="!loading"
        [name]="dropDownName"
        [defaultValue]="defaultOrder"
        [(ngModel)]="order"
        (ngModelChange)="orderChange($event)"
        class="ml-auto">
        <persistent-dropdown-option *optValue="'updatedAt DESC'">
          <i class="fas fa-long-arrow-alt-up mr-2"></i>Newest to oldest
        </persistent-dropdown-option>
        <persistent-dropdown-option *optValue="'updatedAt ASC'">
          <i class="fas fa-long-arrow-alt-down mr-2"></i>Oldest to newest
        </persistent-dropdown-option>
      </persistent-dropdown>
    </div>
    <div *ngIf="isVideoSubscription" class="mt-2 d-flex flex-row align-items-center">
      <button class="btn btn-sm btn-primary" [routerLink]="['new', 99]">
        <i class="mr-1 fas fa-plus"></i>
        New Video Request
      </button>
    </div>
    <div class="mt-3" *ngIf="showNoActiveKeywordsWarning">
      <p>
        <span class="text-danger fas fa-exclamation-circle mr-1"></span>
        <span class="text-danger">Add at least one active request to receive submissions.</span>
      </p>
    </div>
  </div>
</keywords-layout>

<div class="text-center mt-5" *ngIf="!isCustomerCurrent">
  <a *ngIf="customer" [routerLink]="['/dashboard', customer.id, 'plan']">Activate your subscription to create requests</a>
</div>

<div *ngIf="loading" class="my-3">
  <p>loading...</p>
</div>

<div *ngIf="filters.search && keywords.length === 0 && requests.length === 0 && !loading"
  class="my-3">
  <p class="text-muted">We didn't find anything matching your search</p>
</div>

<div *ngIf="!loading">
  <div *ngFor="let displayGroup of selectedStateGroups">
    <div class="my-3" *ngIf="showEmptyState(displayGroup) && !isVideoSubscription">
      <p *ngIf="displayGroup !== 'active'" class="text-muted">
        You have no
        {{displayGroup === 'paused' ? 'inactive' : displayGroup}}
        requests
      </p>
    </div>
    <div class="my-3" *ngIf="isVideoSubscription">
      <ng-container *ngIf="requests | filterRequests:keywordStatesByGroup(displayGroup) as result; else noItems">
        <div *ngFor="let request of result" class="actionable-list-item"
          [ngClass]="{
            'item-inactive': request.state === 'draft',
            'item-deleted': request.state === 'deleted',
            'item-fulfilled': request.state === 'fulfilled',
            'item-active': request.state === 'active'
          }"
        >
          <video-item
            [customerId]="customerId"
            [request]="request"
            [adminImpersonating]="adminImpersonating">
          </video-item>
        </div>
      </ng-container>
      <ng-template #noItems>
        <p *ngIf="showEmptyState(displayGroup)" class="text-muted">
          You have no
          {{displayGroup === 'paused' ? 'inactive' : displayGroup}}
          requests
        </p>
      </ng-template>
    </div>
    <div class="my-3" *ngIf="keywordsByStateGroup[displayGroup].length > 0;">
      <p *ngIf="filters.search" class="bold">{{(displayGroup === 'paused' ? 'inactive' : displayGroup) | titlecase}} Requests</p>
      <div *ngFor="let keyword of keywordsByStateGroup[displayGroup]"
        class="actionable-list-item"
        [ngClass]="displayGroup === 'paused' ? 'item-inactive' : 'item-'+displayGroup">
        <request-item
          [customerId]="customerId"
          [customer]="customer"
          [contentTypes]="contentTypes"
          [contentTypesEnabled]="contentTypesEnabled"
          [keyword]="keyword">
        </request-item>
      </div>
    </div>
  </div>
</div>
<mat-paginator
  *ngIf="showPaginator"
  [length]="totalCount"
  [pageIndex]="page - 1"
  [pageSize]="pageSize"
  [pageSizeOptions]="[25, 50, 100, 200]"
  (page)="onPageChange($event)"
></mat-paginator>
